<template>
  <l-layout :layout="['xs12']">
    <v-card>
      <v-card-title style="height: 64px">
        <span class="title pl-2">{{group.name}}</span>
        <v-layout class="pl-4" wrap>
          <v-flex xs6>
            <span class="grey--text caption mr-2">创建时间</span>
            <span class="pr-4">{{$L.time.stringify(group.creationTime) || 'N/A'}}</span>
          </v-flex>
          <v-flex xs6>
            <span class="grey--text caption mr-2">上次更新</span>
            <span class="pr-4">{{$L.time.stringify(group.lastUpdateTime) || 'N/A'}}</span>
          </v-flex>
        </v-layout>
        <v-spacer></v-spacer>
        <slot name="title-actions"></slot>
        <v-btn flat color="primary" v-if="addVehicleInfo.referIdSlot!==''" @click="goToPassGroup">跳转通行分组</v-btn>
        <v-btn @click="goEdit()" color="primary" flat small>编辑</v-btn>
        <v-btn @click="$emit('refresh')" color="primary" flat small>刷新</v-btn>
      </v-card-title>
      <v-card-text>
        <v-tabs grow v-model="tab">
          <v-tab key="info">单位详情</v-tab>
          <v-tab key="vehicle" v-if="type!=='reservation'">公车管理</v-tab>
        </v-tabs>
        <v-divider></v-divider>
        <v-tabs-items v-model="tab">
          <v-tab-item key="info">
            <l-layout column class="pa-4" :layout="['xs12']">
              <v-container class="py-0" fluid grid-list-md>
                <v-card class="pa-2">
                  <v-layout class="mb-4" wrap>
                    <v-flex xs12 sm6>
                      <v-text-field
                        :label="typeName + '名称'"
                        disabled
                        placeholder="N/A"
                        prepend-icon="$vuetify.icons.group"
                        v-model="group.name"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <v-text-field
                        disabled
                        placeholder="N/A"
                        :label="'父级' + typeName"
                        prepend-icon="$vuetify.icons.groupParent"
                        v-model="group.parentName"
                      ></v-text-field>
                    </v-flex>
                    <v-flex sm4 xs6>
                      <v-text-field
                        :label="typeName + '级别'"
                        disabled
                        placeholder="N/A"
                        prepend-icon="$vuetify.icons.level"
                        v-model="group.codeLevel"
                      ></v-text-field>
                    </v-flex>
                    <v-flex sm4 xs6>
                      <v-text-field
                        :label="typeName + '代码'"
                        disabled
                        placeholder="N/A"
                        prepend-icon="$vuetify.icons.levelCode"
                        v-model="group.code"
                      ></v-text-field>
                    </v-flex>
                    <v-flex sm4 xs12>
                      <v-text-field
                        placeholder="N/A"
                        :label="'分组类型'"
                        v-model="group.type"
                        disabled
                        prepend-icon="$vuetify.icons.group"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                        :label="typeName + '描述'"
                        :rows="1"
                        auto-grow
                        disabled
                        placeholder="N/A"
                        prepend-icon="$vuetify.icons.description"
                        v-model="group.description"
                      ></v-textarea>
                    </v-flex>
                    <v-layout row  wrap>
                      <v-flex xs12>
                        <v-textarea
                          disabled
                          auto-grow
                          label="进场屏显提示词"
                          prepend-icon="$vuetify.icons.led"
                          rows="1"
                          v-model="group.osdMsgIn"
                        ></v-textarea>
                      </v-flex>
                      <v-flex xs12>
                        <v-textarea
                          disabled
                          auto-grow
                          label="进场语音提示词"
                          prepend-icon="$vuetify.icons.audio"
                          rows="1"
                          v-model="group.vcbMsgIn"
                        ></v-textarea>
                      </v-flex>
                      <v-flex xs12>
                        <v-textarea
                          disabled
                          auto-grow
                          label="出场屏显提示词"
                          prepend-icon="$vuetify.icons.led"
                          rows="1"
                          v-model="group.osdMsgOut"
                        ></v-textarea>
                      </v-flex>
                      <v-flex xs12>
                        <v-textarea
                          disabled
                          auto-grow
                          label="出场语音提示词"
                          prepend-icon="$vuetify.icons.audio"
                          rows="1"
                          v-model="group.vcbMsgOut"
                        ></v-textarea>
                      </v-flex>
                    </v-layout>
                  </v-layout>
                </v-card>
              </v-container>
              <v-card class="pa-2 ma-4">
                <v-expand-transition>
                  <v-container class="pt-0" fluid grid-list-md v-if="showUser">
                    <v-subheader>绑定用户</v-subheader>
                    <v-layout class="mb-4" wrap>
                      <v-flex xs12>
                        <l-data-table
                          :get-data-func="getBindUsers"
                          :get-data-payload="group"
                          :headers="userHeaders"
                          auto-actions
                          flat
                          hide-title
                          no-data-text="没有绑定用户"
                        ></l-data-table>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-expand-transition>
                <v-layout>
                  <v-flex class="text-xs-center">
                    <v-btn @click="showUser = !showUser" color="primary" flat>{{showUser ? '收起':'显示'}}已绑定用户</v-btn>
                  </v-flex>
                </v-layout>
              </v-card>
            </l-layout>
          </v-tab-item>
          <v-tab-item key="vehicle">
            <!-- <v-layout  class="mb-3">
               <v-flex xs2 class="mt-3">
                 <v-btn flat color="primary" @click="addVehicle">添加</v-btn>
               </v-flex>
             </v-layout>-->
            <v-btn flat color="primary" @click="addVehicle">添加车辆</v-btn>
           <!-- <l-data-table
              :headers="extraInfo.vehicleHeader"
              :items="extraInfo.vehicleSelect"
              hide-title-search
              hide-refresh
              title-text="无合同车辆列表">
              <template slot="title">
                <span>单位公车列表</span>
              </template>

            </l-data-table>-->
            <v-layout column>
              <l-data-table
              v-for="d in vehicleList"
              :title-text="(d.domain==='')?'无合同单位车辆':d.domain+'车辆列表'"
              :headers="extraInfo.vehicleHeader"
              :items="d.items"
              hide-actions
              hide-refresh>
                <template slot="title">
                  <span>{{(d.domain==='')?'无合同单位车辆':d.domain+'车辆列表'}}</span>
                  <v-btn flat color="primary" @click="readDomain(d.items[0])">查看合同信息</v-btn>
                </template>
                <template slot="row-action" slot-scope="{item}">
                  <v-tooltip bottom>
                    <span>{{item.referIdSlot===''?'删除车辆':'解除绑定'}}</span>
                    <v-btn slot="activator" @click="item.referIdSlot===''?deleteVehicleConfirm(item):unBindVehicleConfirm(item)" icon>
                      <v-icon>{{item.referIdSlot===''?'$vuetify.icons.delete':'$vuetify.icons.lock'}}</v-icon>
                    </v-btn>
                  </v-tooltip>
                  <v-tooltip bottom v-if="item.referIdSlot===''">
                    <span>编辑车辆</span>
                    <v-btn slot="activator" @click="editAddVehicle(item)" icon>
                      <v-icon>$vuetify.icons.edit</v-icon>
                    </v-btn>
                  </v-tooltip>
                  <v-tooltip bottom v-if="item.referIdSlot!==''">
                    <span>查看车辆详情</span>
                    <v-btn slot="activator" @click="goVehicleDetails(item)" icon>
                      <v-icon>$vuetify.icons.description</v-icon>
                    </v-btn>
                  </v-tooltip>
                  <v-tooltip bottom v-if="item.referIdSlot!==''">
                    <span>查看通行规则</span>
                    <v-btn slot="activator" @click="goVehiclePassRules(item)" icon>
                      <v-icon>$vuetify.icons.parkingLot</v-icon>
                    </v-btn>
                  </v-tooltip>
                 <!-- <v-menu  left>
                    <v-btn slot="activator" icon small>
                      <v-icon  small>$vuetify.icons.more</v-icon>
                    </v-btn>
                    <v-list dense>
                      <v-list-tile @click="deleteVehicleConfirm(item)">
                        <v-list-tile-title class="pr-1">
                          删除车辆
                        </v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile @click="editAddVehicle(item)">
                        <v-list-tile-title class="pr-1">
                          编辑车辆
                        </v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>-->
                </template>
              </l-data-table>
            </v-layout>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
    <v-dialog scrollable persistent v-model="addVehicleInfo.activate" max-width="900px">
      <v-card>
        <v-card-title  style="height: 64px">
          <v-layout>
            <h3>{{addVehicleInfo.status==='editVehicle'?'编辑车辆':(addVehicleInfo.status==='new'?'添加车辆':'查看合同信息')}}</h3>
          </v-layout>
          <v-spacer></v-spacer>
          <v-btn icon @click="addVehicleInfo.activate = false">
            <v-icon>{{$vuetify.icons.close}}</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form ref="addVehicleForm">
            <v-layout column>
              <v-layout v-if="addVehicleInfo.status==='new'||addVehicleInfo.status==='readDomain'" column>
                <v-flex class="pa-3">
                  <v-switch v-model="addVehicleInfo.isCo" label="是否以合同方式录入" :disabled="addVehicleInfo.status==='readDomain'"></v-switch>
                </v-flex>
                <v-subheader v-if="addVehicleInfo.isCo">合同信息</v-subheader>
                <v-flex xs4 sm4 v-if="addVehicleInfo.isCo" class="pl-3 pr-3">
                  <v-text-field label="合同名称" prepend-icon="$vuetify.icons.title" v-model="addVehicleInfo.coName" :rules="[$rules.requiredS()]"
                  :disabled="addVehicleInfo.status==='readDomain'"></v-text-field>
                </v-flex>
                <v-layout column class="pl-4" v-if="addVehicleInfo.isCo">
                  <v-flex xs12>
                    <l-image v-if="addVehicleInfo.coImage.length === 0"></l-image>
                    <l-image-dialog
                      :src="img.src"
                      v-for="(img,i) in addVehicleInfo.coImage" :key="i">
                      <l-image
                        slot="activator"
                        :src="img.src"
                        :error="img.error"
                        :errorMessage="img.errorMessage"
                      >
                        <template slot="action">
                          <v-tooltip bottom>
                            <span>删除图像</span>
                            <v-btn slot="activator" @click="deleteImage(addVehicleInfo.coImage, i)" icon>
                              <v-icon>$vuetify.icons.delete</v-icon>
                            </v-btn>
                          </v-tooltip>
                        </template>
                      </l-image>
                    </l-image-dialog>
                  </v-flex>
                  <v-flex xs12>
                    <l-select-file
                      @input="addFile(arguments[0], addVehicleInfo.coImage)"
                      file-type="image/*"
                      title="添加图片"
                    >
                      <v-btn color="primary" flat slot="activator" :disabled="addVehicleInfo.coImage.length===1">
                        上传合作图片<span class="error&#45;&#45;text caption" >（至多只上传一张图片）</span>
                      </v-btn>
                    </l-select-file>
                  </v-flex>
                </v-layout>
                <v-subheader>通行规则</v-subheader>
                <v-layout column>
                  <l-pass-rule-list
                    :pass-rules="addVehicleInfo.passRules"
                    prefix-text="时段"
                  >
                    <template slot="action" slot-scope="{item, index}">
                      <div @click.stop>
                        <v-menu left>
                          <v-btn slot="activator" icon small>
                            <v-icon :color="'grey darken-3'" small>{{$vuetify.icons.more}}
                            </v-icon>
                          </v-btn>
                          <v-list dense>
                            <v-list-tile
                              @click="setRuleDialog={activate: true, status: 'edit',item: item, index: index}">
                              <v-list-tile-title class="pr-1">
                                <v-icon small class="pr-3">{{$vuetify.icons.edit}}</v-icon>
                                编辑
                              </v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile
                              @click="deletePassRule(index)">
                              <v-list-tile-title class="pr-1">
                                <v-icon small class="pr-3">{{$vuetify.icons.delete}}</v-icon>
                                删除
                              </v-list-tile-title>
                            </v-list-tile>
                          </v-list>
                        </v-menu>
                      </div>
                    </template>
                  </l-pass-rule-list>
                  <v-flex xs12>
                    <v-btn
                      flat
                      class="mx-0"
                      color="primary"
                      :disabled="addVehicleInfo.passRules.length===1"
                      @click="
                      setRuleDialog ={
                            activate: true,
                            status: 'new',
                            item: createPassRule(),
                            index: addVehicleInfo.passRules.length
                     }">添加规则</v-btn>
                  </v-flex>
                  <v-dialog scrollable persistent v-model="setRuleDialog.activate" max-width="900px">
                    <set-pass-rule-content
                      :authority="auth"
                      v-if="setRuleDialog.activate"
                      :status="setRuleDialog.status"
                      :rule="setRuleDialog.item"
                      :params="{index: setRuleDialog.index}"
                      @cancel="setRuleDialog.activate=false"
                      @save="setPassRule"
                    ></set-pass-rule-content>
                    <v-divider></v-divider>
                  </v-dialog>
                </v-layout>
              </v-layout>
              <v-layout v-if="addVehicleInfo.status==='new'||addVehicleInfo.status==='editVehicle'" column>
                <v-subheader>车辆列表</v-subheader>
                <l-select-file
                  :dialog-props="vehicleFileProps"
                  :hint="'仅支持Excel(.xlsx)文件'"
                  :rules="vehicleFileRules"
                  @cancel="vehicleFileProps.activate = false"
                  @submit="readExcel"
                  file-type="excel"
                  select-type="dialog"
                >
                  <v-btn class="mx-0" color="primary" flat
                         slot="activator">批量导入
                  </v-btn>
                  <template slot="before-drag">
                    <v-layout align-center class="mb-3 pl-2" row>
                      <span class="body-2">批量添加车辆需要上传特定格式的模板</span>
                      <v-btn
                        @click="getVehicleFileTemplate"
                        color="primary"
                        flat
                        ref="templateBtn"
                        small
                        target="_blank"
                      >点此下载
                      </v-btn>
                    </v-layout>
                  </template>
                </l-select-file>
                <v-layout v-for="(v,index) in addVehicleInfo.vehicleInfo" :key="index" v-if="addVehicleInfo.vehicleInfo.length!==0" class="pl-4" column>
                  <v-layout>
                    <v-flex xs6 class="pt-5">
                      <l-plate-picker v-model="v.plate" :rules="[$rules.requiredS()]"></l-plate-picker>
                    </v-flex>
                    <v-layout column xs6 class="pl-4">
                      <v-flex xs12>
                        <l-image v-if="v.image.length === 0"></l-image>
                        <l-image-dialog
                          :src="img.src"
                          v-for="(img,i) in v.image" :key="i">
                          <l-image
                            slot="activator"
                            :src="img.src"
                            :error="img.error"
                            :errorMessage="img.errorMessage"
                          >
                            <template slot="action">
                              <v-tooltip bottom>
                                <span>删除图像</span>
                                <v-btn slot="activator" @click="deleteImage(v.image, i)" icon>
                                  <v-icon>$vuetify.icons.delete</v-icon>
                                </v-btn>
                              </v-tooltip>
                            </template>
                          </l-image>
                        </l-image-dialog>
                      </v-flex>
                      <v-flex xs12>
                        <l-select-file
                          @input="addFile(arguments[0], v.image)"
                          file-type="image/*"
                          title="添加图片"
                        >
                          <v-btn color="primary" flat slot="activator" :disabled="v.image.length===1">
                            上传行驶证<span class="error&#45;&#45;text caption" >（至多只上传一张图片）</span>
                          </v-btn>
                        </l-select-file>
                      </v-flex>
                    </v-layout>
                  </v-layout>
                  <v-divider></v-divider>
                </v-layout>
                <v-layout justify-center v-if="addVehicleInfo.status === 'new'">
                  <v-btn icon @click="addVehicleItem">
                    <v-icon color="primary">{{$vuetify.icons.add}}</v-icon>
                  </v-btn>
                </v-layout>
              </v-layout>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn class="primary" @click="submitAddVehicle" :laoding="addVehicleInfo.loading">提交</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </l-layout>
</template>

<script>
  import {time} from '../../../ladmin/utils'
  import {Group, PassRule, ReservationAuthority} from '../../../object'
  import LPlatePicker from '@/components/LPlatePicker'
  import SetPassRuleContent from '../../../components/SetPassRuleContent'
  import LPassRuleList from '../../../components/LPassRuleList'
  import LDataTable from "../../../ladmin/components/LDataTable/LDataTable"
  import XLSX from 'xlsx'
  let errorMap = {
    '1': '电话格式有误',
    '2': '车牌号码有误'
  }
  export default {
    name: 'cooperateOrganizationDetail',
    props: {
      type: {type: String, default: ''},
      group: {type: Object, default: () => (new Group())}
    },
    components: {
      LDataTable,
      LPlatePicker,
      SetPassRuleContent,
      LPassRuleList
    },
    data: () => ({
      showUser: false,
      roleHeaders: [
        {text: '角色名称', value: 'name', align: 'left', placeholder: 'N/A'},
        {text: '角色描述', value: 'description', align: 'right', placeholder: 'N/A'},
        {text: '上次修改', value: 'lastEditor', align: 'right', placeholder: 'N/A'},
        {text: '创建时间', value: 'creationTime', align: 'right', placeholder: 'N/A', f: v => time.stringify(v)},
      ],
      userHeaders: [
        {text: '用户姓名', value: 'name', align: 'left', placeholder: 'N/A'},
        {text: '用户账号', value: 'loginId', align: 'right', placeholder: 'N/A'},
        {text: '上次修改', value: 'lastEditor', align: 'right', placeholder: 'N/A'},
        {text: '创建时间', value: 'creationTime', align: 'right', placeholder: 'N/A', f: v => time.stringify(v)},
      ],
      tab: 0,
      addAdminInfo:{
        activated:false,
        type:'vehicle'
      },
      userType:'vehicle',
      extraInfo: {
        admin: '',
        adminSelect: [],
        vehicle: '',
        vehicleSelect: [],
        groupUserSelect: [],
        adminHeader: [
          {text: '管理员姓名', value: 'name', align: 'left', sortable: false},
          {text: '管理员ID', value: 'loginId', align: 'left'},
          {text: '管理类型', value: 'type', align: 'left',f:(v)=>(v==='vehicle'?"车行管理":(v==='all')?"人行管理&车行管理":"人行管理")},
          {text: '', value: '', sortable: false}
        ],
        vehicleHeader: [
          {text: '车牌号', value: 'code', align: 'left'},
          {text: '绑定状态', value: 'referIdSlot', align: 'left',f:(v)=>(v===''?'未绑定':'已绑定')},
          {text: '', value: '', sortable: false}
        ],
        showDrivers: false,
        showAdmins: false,
        showVehicles: false
      },
      addVehicleInfo: {
        activate: false,
        vehicleInfo: [],
        passRules: [],
        isCo: false,
        coName: '',
        coImage: [],
        loading: false,
        status: 'new',
        index: 0,
        referIdSlot: ''
      },
      vehicleList:[],
      /* 通行规则配置相关使用参数 */
      setRuleDialog: {
        activate: false,
        status: 'new',
        item: {},
        index: 0,
      },
      ownerId: '',
      vehicleFileProps: {
        activate: true,
        autoClose: true,
        title: '批量添加车辆',
      },
      vehicleFileRules: [
        v => !(!v || v.length === 0) || '必选',
        v => !v.some(f => !/\.xlsx$/i.test(f.name)) || '仅支持Excel表格(.xlsx)格式',
      ],
      importErrorDialog: {
        activate: false,
        vehicles: [],
        fails: [],
        duplicates: [],
        haveDuplicatePlate: false,
      },
    }),
    computed: {
      controllerList () {
        return this.$store.state.parkingLot.controllerList
      },
      isOrg () {
        return this.type === Group.ORGANIZATION
      },
      typeName () {
        if (this.isOrg) {
          return '单位'
        }
        else {
          return '分组'
        }
      },
      auth () {
        let auth = this.$store.state.reservation.adminAuth
        auth.editPrompt = false
        return auth
        /* new ReservationAuthority({
          name: '合作用户规则',
          maxVehicleAmount: 1000,
          maxStartDay: 30,
          maxDurationDay: 30
        }) */
      },
    },
    created () {
      this.getReservationConfig()
      this.ownerId = this.$route.query.id
      this.getExtraConfig()
    },
    methods: {
      getExtraConfig () {
        this.getVehicles()
      },
      getBindUsers (params, group) {
        // console.log(params)
        return this.$store.dispatch('userAdmin/getUsersByGroup', {params, group})
      },
      goEdit () {
        this.$store.dispatch('L/routerInTab').then(() => {
          this.$router.replace({
            name: this.isOrg ? 'EditOrg' : 'EditGroup',
            params: this.$route.params,
            query: this.$route.query
          })
        })
      },
      async getGroupUsers (data) {
        let search = (data === undefined) ? '' : data.target.value
        let pagination = {page: 0, rowsPerPage: 10}
        let param = {
          'searchParam': {
            'name': {
              'index': '1',
              'order': 'DESC',
              'operators': [
                {
                  'keyword': search,
                  'operator': 'LIKE',
                  'matchType': 'BOTH'
                }
              ]
            }
          }
        }
        let res = await this.$store.dispatch('reservationConfig/getGroupUsers', {param: param, pagination: pagination, id: this.ownerId})
        if (res.data.status === 1) {
          // alert(1)
          // console.log(res)
          this.extraInfo.groupUserSelect = res.data.data.content
          console.log(this.extraInfo.groupUserSelect)
        }
        else {
          this.extraInfo.groupUserSelect = []
        }
      },
      addAdmin () {
        if (this.extraInfo.admin === '') {
          this.$L.alert('error', {message: '添加管理员不能为空'})
          return
        }
        let vehicle_ids = []
        let person_ids = []
        for (let n in this.extraInfo.adminSelect) {
          let extend = {
            name: this.extraInfo.adminSelect[n].name,
            loginId: this.extraInfo.adminSelect[n].loginId,
          }
          let obj = {
            code: this.extraInfo.adminSelect[n].code,
            files: '',
            domain: '',
            domainFileExtend: '',
            referIdSlot: '',
            extend: JSON.stringify(extend),
          }
          if(this.extraInfo.adminSelect[n].type==='vehicle'){
            vehicle_ids.push(obj)
          }
          else if(this.extraInfo.adminSelect[n].type==='person'){
            person_ids.push(obj)
          }else{
            vehicle_ids.push(obj)
            person_ids.push(obj)
          }
        }
        let extend = {
          name: this.extraInfo.admin.name,
          loginId: this.extraInfo.admin.loginId
        }
        let obj = {
          code: this.extraInfo.admin.id,
          files: '',
          domain: '',
          domainFileExtend: '',
          referIdSlot: '',
          extend: JSON.stringify(extend),
        }
        if(this.addAdminInfo.type === 'vehicle'){
          vehicle_ids.push(obj)
        }else if(this.addAdminInfo.type === 'person'){
          person_ids.push(obj)
        }else{
          vehicle_ids.push(obj)
          person_ids.push(obj)
        }
        this.extraInfo.admin = ''
        this.updateAdmin(vehicle_ids,person_ids)
      },
      async updateAdmin (vehicle_ids,person_ids) {
        let vehicle_res = await this.$store.dispatch('vehicleRegister/addExtraConfig', {id: this.ownerId, type: 'admin', ids: vehicle_ids,userType:'vehicle'})
        let person_res = await this.$store.dispatch('vehicleRegister/addExtraConfig', {id: this.ownerId, type: 'admin', ids: person_ids,userType:'person'})
        if (vehicle_res.data.status === 1&&person_res.data.status===1) {
          this.$L.alert('success', {message: '更新成功'})
          this.getAdmins()
        }
        else {
          if(vehicle_res.data.status !== 1){
            this.$L.alert('error', {message: vehicle_res.data.msg})
          }
          else{
            this.$L.alert('error', {message: person_res.data.msg})
          }
        }
      },
      async getAdmins () {
        let res1 = await this.$store.dispatch('vehicleRegister/getExtraConfig', {id: this.ownerId, type: 'admin',userType:'vehicle'})
        let res2 = await this.$store.dispatch('vehicleRegister/getExtraConfig', {id: this.ownerId, type: 'admin',userType:'person'})
        this.addAdminInfo.activated = false
        if (res1.data.status === 1) {
          if (res1.data.data === '[]') {
            return
          }
          this.extraInfo.adminSelect = []
          let array = JSON.parse(res1.data.data)
          array = array.configs
          for (let i = 0; i < array.length; i++) {
            let item = array[i]
            if (item.extend !== '') {
              item.name = JSON.parse(item.extend).name || ''
              item.loginId = JSON.parse(item.extend).loginId || ''
              item.type = 'vehicle'
            }
            this.extraInfo.adminSelect.push(item)
          }
          // console.log(this.extraInfo.adminSelect)
        }
        else {
          this.extraInfo.adminSelect = []
          //this.$L.alert('error', {message: '获取单位管理员列表失败，原因：' + res1.data.msg})
        }
        if (res2.data.status === 1) {
          if (res2.data.data === '[]') {
            return
          }
          let array = JSON.parse(res2.data.data)
          array = array.configs
          for (let i = 0; i < array.length; i++) {
            let item = array[i]
            if (item.extend !== '') {
              item.name = JSON.parse(item.extend).name || ''
              item.loginId = JSON.parse(item.extend).loginId || ''
              item.type = 'person'
            }
            let flag = false
            for(let j=0;j<this.extraInfo.adminSelect.length;j++){
              if(item.loginId === this.extraInfo.adminSelect[j].loginId){
                this.extraInfo.adminSelect[j].type = 'all'
                flag = true
              }
            }
            if(!flag){
              this.extraInfo.adminSelect.push(item)
            }
          }
          // console.log(this.extraInfo.adminSelect)
        }
        else {
          return
          //this.$L.alert('error', {message: '获取单位管理员列表失败，原因：' + res1.data.msg})
        }
      },
      async deleteAdminConfirm(item){
        let {res, close} = await this.$L.confirm({
          title: '确认删除该单位管理员？',
          text: '管理员名称:' + item.name
        })
        if (res) {
          try {
            await this.deleteAdmin(item)
          }
          catch (e) {
            this.$L.alert('error', e.message)
          }
        }
        close()
      },
      deleteAdmin (item) {
        let index
        for (let i = 0; i < this.extraInfo.adminSelect.length; i++) {
          if (this.extraInfo.adminSelect[i].code === item.code) {
            index = i
            break
          }
        }
        // console.log(this.extraInfo.adminSelect)
        this.extraInfo.adminSelect.splice(index, 1)
        let vehicle_ids = []
        let person_ids = []
        for (let n in this.extraInfo.adminSelect) {
          let extend = {
            name: this.extraInfo.adminSelect[n].name,
            loginId: this.extraInfo.adminSelect[n].loginId,
          }
          let obj = 	{
            code: this.extraInfo.adminSelect[n].code,
            files: '',
            domain: '',
            domainFileExtend: '',
            referIdSlot: '',
            extend: JSON.stringify(extend),
          }
          if(this.extraInfo.adminSelect[n].type==='vehicle'){
            vehicle_ids.push(obj)
          }else if(this.extraInfo.adminSelect[n] === 'person'){
            person_ids.push(obj)
          }else{
            vehicle_ids.push(obj)
            person_ids.push(obj)
          }
        }
        this.updateAdmin(vehicle_ids,person_ids)
      },
      addVehicle () {
        this.resetAddVehicleInfo()
        this.addVehicleInfo.activate = true
      },
      addVehicleItem () {
        this.addVehicleInfo.vehicleInfo.push({
          plate: '',
          image: []
        })
      },
      readDomain(item){
        this.resetAddVehicleInfo()
        this.addVehicleInfo.coName = item.domain
        let domianImage = new Image()
        if (item.domainFileExtend !== '') {
          let domianImageJson = JSON.parse(item.domainFileExtend)
          if (domianImageJson.pic[2].url3 !== '') {
            domianImage.url = domianImageJson.pic[2].url3
            this.getImg(domianImage)
            this.addVehicleInfo.coImage.push(domianImage)
          }
        }
        let rule = JSON.parse(item.extend).rule
        rule = JSON.parse(rule)
        this.addVehicleInfo.passRules.push(PassRule.fromAPI(rule[0], this.controllerList))
        this.addVehicleInfo.passRules.forEach(function (r) {
          r.audioPromptIn = false
          r.audioPromptOut = false
          r.ledPromptIn = false
          r.ledPromptOut = false
        })
        this.addVehicleInfo.activate = true
        if (this.addVehicleInfo.coImage.length !== 0) {
          this.addVehicleInfo.isCo = true
        }
        this.addVehicleInfo.status = 'readDomain'
        for (let i = 0; i < this.extraInfo.vehicleSelect.length; i++) {
          if (item.code === this.extraInfo.vehicleSelect[i].code) {
            this.addVehicleInfo.index = i
            break
          }
        }
      },
      editAddVehicle (item) {
        this.resetAddVehicleInfo()
        this.addVehicleInfo.coName = item.domain
        let domianImage = new Image()
        if (item.domainFileExtend !== '') {
          let domianImageJson = JSON.parse(item.domainFileExtend)
          if (domianImageJson.pic[2].url3 !== '') {
            domianImage.url = domianImageJson.pic[2].url3
            this.getImg(domianImage)
            this.addVehicleInfo.coImage.push(domianImage)
          }
        }
        this.addVehicleItem()
        let vehicleImage = new Image()
        let vehicleImageJson = JSON.parse(item.files)
        if (vehicleImageJson.pic[1].url2 !== '') {
          vehicleImage.url = vehicleImageJson.pic[1].url2
          this.getImg(vehicleImage)
        }
        this.addVehicleInfo.vehicleInfo[0].plate = item.code
        this.addVehicleInfo.vehicleInfo[0].image.push(vehicleImage)
        let rule = JSON.parse(item.extend).rule
        rule = JSON.parse(rule)
        this.addVehicleInfo.passRules.push(PassRule.fromAPI(rule[0], this.controllerList))
        this.addVehicleInfo.passRules.forEach(function (r) {
          r.audioPromptIn = false
          r.audioPromptOut = false
          r.ledPromptIn = false
          r.ledPromptOut = false
        })
        this.addVehicleInfo.activate = true
        if (this.addVehicleInfo.coImage.length !== 0) {
          this.addVehicleInfo.isCo = true
        }
        this.addVehicleInfo.status = 'editVehicle'
        for (let i = 0; i < this.extraInfo.vehicleSelect.length; i++) {
          if (item.code === this.extraInfo.vehicleSelect[i].code) {
            this.addVehicleInfo.index = i
            break
          }
        }
      },
      goToPassGroup () {
        this.$router.push({
          name: 'passGroupDetails',
          params: {id: this.addVehicleInfo.referIdSlot},
          query: {id: this.addVehicleInfo.referIdSlot}
        })
      },
      submitAddVehicle () {
        if (!this.checkAddVehicle()) {
          return
        }
        let configs = []
        if(this.addVehicleInfo.status === 'readDomain'){
          let ruleArr = []
          ruleArr.push(this.addVehicleInfo.passRules[0].toAPI())
          let extend = {
            rule: JSON.stringify(ruleArr)
          }
          for (let i = 0; i < this.extraInfo.vehicleSelect.length; i++) {
            this.extraInfo.vehicleSelect[i].extend = JSON.stringify(extend)
            configs.push(this.extraInfo.vehicleSelect[i])
          }
        }else{
          for (let i = 0; i < this.addVehicleInfo.vehicleInfo.length; i++) {
            let item = this.addVehicleInfo.vehicleInfo[i]
            console.log(item)
            let files = {
              pic: [
                {name: '驾驶证', url1: ''},
                {name: '行驶证', url2: item.image.length===0?'':item.image[0].url},
                {name: '其他证明', url3: ''}
              ],
              msg: ''
            }
            let domainFileExtend = {
              pic: [
                {name: '驾驶证', url1: ''},
                {name: '行驶证', url2: item.image.url || ''},
                {name: '其他证明', url3: this.addVehicleInfo.coImage.length === 0 ? '' : this.addVehicleInfo.coImage[0].url}
              ],
              msg: ''
            }
            let ruleArr = []
            ruleArr.push(this.addVehicleInfo.passRules[0].toAPI())
            let extend = {
              rule: JSON.stringify(ruleArr)
            }
            let vehicle = {
              code: item.plate,
              files: JSON.stringify(files),
              domain: this.addVehicleInfo.coName,
              domainFileExtend: (this.addVehicleInfo.isCo) ? JSON.stringify(domainFileExtend) : '',
              referIdSlot: '',
              extend: JSON.stringify(extend),
            }
            configs.push(vehicle)
          }
          if (this.addVehicleInfo.status === 'editVehicle') {
            this.extraInfo.vehicleSelect.splice(this.addVehicleInfo.index, 1)
          }
          for (let i = 0; i < this.extraInfo.vehicleSelect.length; i++) {
            configs.push(this.extraInfo.vehicleSelect[i])
          }
        }
        this.updateVehicle(configs)
      },
      resetAddVehicleInfo () {
        this.addVehicleInfo.activate = false
        this.addVehicleInfo.isCo = false
        this.addVehicleInfo.coName = ''
        this.addVehicleInfo.coImage = []
        this.addVehicleInfo.passRules = []
        this.addVehicleInfo.vehicleInfo = []
        this.addVehicleInfo.status = 'new'
      },
      checkAddVehicle () {
        if (this.addVehicleInfo.passRules.length === 0) {
          this.$L.alert('error', {message: '请先配置通行规则'})
          return false
        }
        if (this.addVehicleInfo.vehicleInfo.length === 0&&this.addVehicleInfo.status!=='readDomain') {
          this.$L.alert('error', {message: '请添加车辆'})
          return false
        }
        if (this.addVehicleInfo.isCo && this.addVehicleInfo.coImage.length === 0) {
          this.$L.alert('error', {message: '请上传合作证明'})
          return false
        }
        if (!this.$refs.addVehicleForm.validate()) {
          this.$L.alert('error', {message: '表单数据错误'})
          return false
        }
        return true
      },
      async updateVehicle (ids) {
        this.addVehicleInfo.loading = true
        let res = await this.$store.dispatch('vehicleRegister/addExtraConfig', {id: this.ownerId, type: 'vehicle', ids: ids,userType:this.userType,referIdSlot:this.addVehicleInfo.referIdSlot})
        this.addVehicleInfo.loading = false
        if (res.data.status === 1) {
          this.$L.alert('success', {message: '更新成功'})
          this.resetAddVehicleInfo()
          this.getVehicles()
        }
        else {
          this.$L.alert('error', {message: res.data.msg})
        }
      },
      async getVehicles () {
        let res1 = await this.$store.dispatch('vehicleRegister/getExtraConfig', {id: this.ownerId, type: 'vehicle',userType:this.userType})
        if (res1.data.status === 1) {
          if (res1.data.data === '[]') {
            return
          }
          this.extraInfo.vehicleSelect = []
          let data = JSON.parse(res1.data.data)
          let referIdSlot = data.referIdSlot
          if (referIdSlot !== '') {
            this.addVehicleInfo.referIdSlot = referIdSlot
          }
          let array = data.configs
          for (var i = 0; i < array.length; i++) {
            let item = array[i]
            this.extraInfo.vehicleSelect.push(item)
          }
          this.dealVehicleList(this.extraInfo.vehicleSelect)
        }
        else {
          // this.$L.alert('error', {message: '获取驾驶员列表失败，原因：' + res1.data.msg})
        }
      },
      dealVehicleList(arr){
        this.vehicleList = []
        for(let i=0;i<arr.length;i++){
          let flag = false
          for(let j=0;j<this.vehicleList.length;j++){
            if(arr[i].domain === this.vehicleList[j].domain){
              this.vehicleList[j].items.push(arr[i])
              flag = true
              break
            }
          }
          if(!flag){
            let obj = {
              domain:arr[i].domain,
              items:[arr[i]]
            }
            this.vehicleList.push(obj)
          }
        }
      },
      async deleteVehicleConfirm(item){
        let {res, close} = await this.$L.confirm({
          title: '确认删除该车辆？',
          text: '车牌号码:' + item.code
        })
        if (res) {
          try {
            await this.deleteVehicle(item)
          }
          catch (e) {
            this.$L.alert('error', e.message)
          }
        }
        close()
      },
      async unBindVehicleConfirm(item){
        let {res, close} = await this.$L.confirm({
          title: '确认解除该车辆绑定？',
          text: '车牌号码:' + item.code
        })
        if (res) {
          try {
            await this.unBindVehicle(item,'true')
          }
          catch (e) {
            this.$L.alert('error', e.message)
          }
        }
        close()
      },
      async unBindVehicle (items,status) {
        let ids = []
        ids.push(items.code)
        let res = await this.$store.dispatch('vehicleRegister/deleteVehicles', {ids:ids,status:status})
        if (res.data.status === 1) {
          this.$L.alert('success', {message: '解绑成功'})
          this.getVehicles()
        }
        else {
          this.$L.alert('error',{message:res.data.msg})
        }
      },
      deleteVehicle (item) {
        let ids = []
        for (let i = 0; i < this.extraInfo.vehicleSelect.length; i++) {
          if (this.extraInfo.vehicleSelect[i].code === item.code) {
            continue
          }else{
            ids.push(this.extraInfo.vehicleSelect[i])
          }
        }
       // console.log(ids)
        this.updateVehicle(ids)
      },
      createPassRule () {
        return new PassRule()
      },
      /* set通行规则 */
      setPassRule (res) {
        this.setRuleDialog.activate = false
        let {status, newItem, oldItem} = res
        if (status === 'new') {
          newItem.audioPromptIn = false
          newItem.audioPromptOut = false
          newItem.ledPromptIn = false
          newItem.ledPromptOut = false
          this.addVehicleInfo.passRules.push(newItem)
        }
        else if (status === 'edit') {
          newItem.audioPromptIn = false
          newItem.audioPromptOut = false
          newItem.ledPromptIn = false
          newItem.ledPromptOut = false
          this.addVehicleInfo.passRules[this.setRuleDialog.index] = newItem
          console.log(newItem)
        }
      },
      /* 删除通行规则 */
      deletePassRule (index) {
        this.addVehicleInfo.passRules.splice(index, 1)
      },
      async getReservationConfig () {
        let res = await this.$store.dispatch('reservationConfig/getReservationConfig', 'admin')
        // console.log(res.data.data)
        if (res.data.status === 1) {
          let object = new ReservationAuthority({
            name: '高级预约',
            maxVehicleAmount: 1000,
            maxStartDay: -1,
            maxDurationDay: res.data.data.maxDurDays,
            presetCtrls: res.data.data.presetCtrls,
            type: ['sectional', 'day', 'week'],

            // 是否可以定义分组名称和描述
            editGroupInfo: true,

            // 是否可定义特殊进出场提示
            editPrompt: true
          })
          // console.log(object)
          this.$store.commit('reservation/setAdminAuth', object)
        }
        else {
          this.$L.alert('error', {message: '查询预约配置失败，原因：' + res.data.msg})
        }
      },
      async addFile (file, target) {
        // file 实际上为fileList
        let imageCheckType = ['jpg', 'jpeg', 'png', 'gif']
        let IMAGE_MAX_SIZE = 5 * 1000 * 1000
        for (let f of file) {
          let checkType = imageCheckType
          let maxSize = IMAGE_MAX_SIZE
          // console.log('get file', f)
          let suffix = /\.([^.]*)$/i.exec(f.name)[1]
          if (checkType.indexOf(suffix) === -1) {
            this.$L.error({
              title: '上传文件格式错误',
              message: `上传格式: ${suffix}, 支持的格式: ${checkType.join(',')}`
            })
            return
          }
          else if (f.size > maxSize) {
            this.$L.error({
              title: '文件容量过大',
              message: `文件大小: ${Math.round(f.size / 1000)}KB, 最大限制: ${Math.round(maxSize / 1000)}KB`
            })
            return
          }
        }

        let temp = new Image()
        temp.loading = true
        if (target instanceof Array) {
          target.push(temp)
          // 上传图片
          let img = await this.uploadFile(file)
          this.$set(target, target.length - 1, img)
          // console.log(this.vehicleForm.driverLicense)
          this.getImg(img)
        }
      },
      deleteImage (target, i) {
        target.splice(i, 1)
      },
      async uploadFile (files) {
        if (files instanceof Object && files.length > 0) {
          let file = files[0]
          let img = new Image()
          // console.log(img)
          try {
            let res = await this.$store.dispatch('uploadFile', {file, url: '/passApi/check/file'})
            img.url = res
          }
          catch (e) {
            img.error = true
            img.errorMessage = e.message
          }
          return img
        }
      },
      async getImg (img) {
        // console.log(img)
        img.loading = true
        let path = img.url
        this.$set(img, 'src', 'https://smaco2.uestc.edu.cn/passApi' + path)
        img.loading = false
      },
      async getReservationOrgConfig(){
        let filter = [
          {key:'ownerType',value:'group'},
          {key:'orderType',value:'order_group'},
          {key:'ownerId',value:this.group.id}
        ]
        let pagination = {
          page:1,
          rowsPerPage: 10
        }
        let res = null
        if(this.reservationType==='vehicle'){
          res = await this.$store.dispatch('reservationConfig/getConfigListNew',{pagination:pagination,filter:filter})
        }
        if(res.items.length===0){
          this.hasOrgConfig = false
        }else{
          this.hasOrgConfig = true
        }
      },
      async getReservationPersonConfig(){
        let filter = [
          {key:'ownerType',value:'group'},
          {key:'orderType',value:'order_object'},
          {key:'ownerId',value:this.group.id}
        ]
        let pagination = {
          page:1,
          rowsPerPage: 10
        }
        let res = null
        if(this.reservationType==='vehicle'){
          res = await this.$store.dispatch('reservationConfig/getConfigListNew',{pagination:pagination,filter:filter})
        }
        if(res.items.length===0){
          this.hasPersonConfig = false
        }else{
          this.hasPersonConfig = true
        }
      },
      createOrgConfig(){
        if(this.reservationType==='vehicle'){
          this.$router.push({
            name: 'NewPersonalGroupConfig',
            query: {
              ownerId: this.group.id,
              orderType: 'order_group',
              status: 'new',
              ownerType: 'group',
            }
          })
        }else{
          this.$router.push({
            name: 'PersonNewPersonalGroupConfig',
            query: {
              ownerId: this.group.id,
              orderType: 'order_group',
              status: 'new',
              ownerType: 'group',
            }
          })
        }
      },
      createPersonConfig(){
        if(this.reservationType==='vehicle'){
          this.$router.push({
            name: 'NewPersonalGroupConfig',
            query: {
              ownerId: this.group.id,
              orderType: 'order_object',
              status: 'new',
              ownerType: 'group',
            }
          })
        }else{
          this.$router.push({
            name: 'PersonNewPersonalGroupConfig',
            query: {
              ownerId: this.group.id,
              orderType: 'order_object',
              status: 'new',
              ownerType: 'group',
            }
          })
        }
      },
      goOrgConfig(){
        if(this.reservationType==='vehicle'){
          this.$router.push({
            name: 'ConfigDetail',
            query: {
              ownerId: this.group.id,
              orderType: 'order_group',
              status: 'readonly',
              ownerType: 'group'
            }
          })
        }else{
          this.$router.push({
            name: 'PersonConfigDetail',
            query: {
              ownerId: this.group.id,
              orderType: 'order_group',
              status: 'readonly',
              ownerType: 'group'
            }
          })
        }
      },
      goPersonConfig(){
        if(this.reservationType==='vehicle'){
          this.$router.push({
            name: 'ConfigDetail',
            query: {
              ownerId: this.group.id,
              orderType: 'order_object',
              status: 'readonly',
              ownerType: 'group'
            }
          })
        }else{
          this.$router.push({
            name: 'PersonConfigDetail',
            query: {
              ownerId: this.group.id,
              orderType: 'order_object',
              status: 'readonly',
              ownerType: 'group'
            }
          })
        }
      },
      goVehicleDetails(item){
        this.$router.push({
          name: 'vehicleDetailContentBox',
          query: {
            plate: item.code,
            status: 'readonly'
          },
        })
      },
      goVehiclePassRules(item){
        this.$router.push({
          name: 'vehicleRuleDetailsBox',
          query: {
            id: item.code,
          }
        })
      },
      async getVehicleFileTemplate () {
        try {
          let url = await this.$store.dispatch('userAdmin/getVehicleFileTemplate')
          let isSupportDownload = 'download' in document.createElement('a')
          console.log('get url', url, isSupportDownload)
          let el = document.createElement('a')
          el.href = url
          el.target = '_blank'
          el.download = '合作单位车辆批量导入模版'
          el.style.display = 'none'
          document.body.appendChild(el)
          el.click()
          document.body.removeChild(el)
        }
        catch (e) {
          this.$L.alert('error', {title: '获取模板时发生错误', message: e.message, raw: e})
        }
      },
      resetImportDialog () {
        this.importErrorDialog = {
          activate: false,
          vehicles: [],
          fails: [],
          duplicates: [],
          haveDuplicatePlate: false,
        }
      },
      importVehicle (vehicles) {
        if (vehicles) {
          this.addVehicleInfo.vehicleInfo.push(...vehicles)
          this.$L.alert('success', {message: `成功导入${vehicles.length}项`})
        }
        this.resetImportDialog()
      },
      checkVehicle (v) {
        if (!this.$reg.PLATE_PATTERN.test(v.plate.trim())) {
          return 2
        }
        return 0
      },
      readExcel (files) {
        let f = files[0]
        if (!(f instanceof File)) return
        let reader = new FileReader()
        reader.onload = (event) => {
          try {
            let data = event.target.result
            let workbook = XLSX.read(data, {type: 'array'})
            let keys = Object.keys(workbook.Sheets)
            if (Object.keys(workbook.Sheets).length < 1) {
              throw Error('模板格式错误')
            }
            let sheet = workbook.Sheets[keys[0]]
            let ref = sheet['!ref']
            let group = /^[A-Z]+(\d+):[A-Z]+(\d+)$/.exec(ref)
            if (!group) {
              throw Error('模板格式错误')
            }
            let s = Number(group[1])
            let e = Number(group[2])
            let atters = ['A', 'B', 'C', 'D', 'E', 'F']
            let vehicles = []
            let fails = []
            let duplicates = []
            let haveDuplicatePlate = false

            for (let i = s + 1; i <= e; ++i) {
              let plate = sheet[atters[0] + i] ? sheet[atters[0] + i].w.trim() : ''
              if (!plate) {
                continue
              }
              // 文字转key
              let v = {
                plate:plate,
                image: []
              }
              let checkRes = this.checkVehicle(v)
              if (checkRes === 0) {
                if (this.addVehicleInfo.vehicleInfo.find(t => t.plate === v.plate)) {
                  duplicates.push(v)
                }
                else {
                  let tmp = vehicles.find(t => t.plate === v.plate)
                  if (tmp) {
                    console.log('find duplicate', tmp, v)
                    haveDuplicatePlate = true
                  }
                  else {
                    vehicles.push(v)
                  }
                }
              }
              else {
                v.error = errorMap[checkRes]
                fails.push(v)
              }
            }
            // 需要补全错误提示代码
            // this.importErrorDialog = {
            //   activate: true,
            //   vehicles: vehicles,
            //   fails: fails,
            //   duplicates: duplicates
            // }
            console.log('check import', fails, duplicates, vehicles)
            if (fails.length === 0 && duplicates.length === 0 && !haveDuplicatePlate) {
              this.importVehicle(vehicles)
              // this.reservation.vehicles.push(...vehicles)
              // this.$store.commit('toggleSnackbar', {message: `成功导入${vehicles.length}项`})
            }
            else {
              this.importErrorDialog = {
                activate: true,
                vehicles: vehicles,
                fails: fails,
                duplicates: duplicates,
                haveDuplicatePlate: haveDuplicatePlate,
              }
            }
          }
          catch (e) {
            alert(e)
            this.$L.alert({title: '读取导入模板时发生错误', message: '给定的文件格式错误，或浏览器版本不支持'})
          }
        }
        reader.readAsArrayBuffer(f)
      },
    },
    watch:{
      userType(){
        this.getExtraConfig()
      },
      reservationType(){
        this.getReservationOrgConfig()
        this.getReservationPersonConfig()
      }
    }
  }
</script>

<style scoped>

</style>
